import Vue from "vue";
import Vuetify from "vuetify/lib";
//import sv from "i18n/vuetify/sv";
import VueI18n from "vue-i18n";
import sv from "vuetify";

Vue.use(Vuetify);
Vue.use(VueI18n);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#FFA500",
                secondary: "#000000"
            }
        },
        lang: {
            locales: sv,
            current: "sv"
        }
    }
});
